import React from 'react';

const TabPanel = ({ children, value, index }) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`map-tabpanel-${index}`}
            aria-labelledby={`map-tab-${index}`}
            className={`${value === index ? 'block' : 'hidden'} w-full`}
        >
            {value === index && (
                <div className="py-4">
                    {children}
                </div>
            )}
        </div>
    );
};

export default TabPanel; 